<template>
    <div ref="container" class="">

        <header class="pt-3 pb-3 text-center">
            <h1 class='h2'>{{ $t('translations.hello')}} {{formatName($root.user)}}</h1>
        </header>

        <div class="card-default">

            <div class="patient-banner">
                <h5>
                    <span style='white-space: nowrap;'><strong>{{formatNameCompliant($root.user)}}</strong></span>
                    <span style='white-space: nowrap;'>{{ $t('translations.born')}}: <strong>{{$root.user.dob | formatDate}} ({{$root.user.dob | getAge}}y)</strong></span>
                    <span style='white-space: nowrap;'>{{ $t('translations.gender')}}: <strong>{{getGender($root.user.gender)}}</strong></span>
                    <!-- <span style='white-space: nowrap;'>{{$t('translations.NHS_number')}}: <strong>{{$root.user.nhs_number}}</strong></span> -->
                </h5>

                <h5>
                    <span style='white-space: nowrap;'>{{ $t('translations.address')}} <strong>{{this.formatAddress($root.user.address_line_1, $root.user.address_line_2, $root.user.address_line_3,$root.user.address_line_4,$root.user.postcode)}}</strong></span>
                    <span style='white-space: nowrap;'>{{ $t('translations.phone_and_email')}} <strong>{{$root.user.phone_number}}, {{$root.user.email}}</strong></span>
                </h5>
            </div>

            <p> {{ $t('translations.are_these_details_correct_if_not_contact_your_practice', {"provider_generic_term": this.tBrand("provider_generic_term")}) }} . </p>

        </div>

    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {

        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {

    }
}

</script>
